import request from '@/utils/request';
import {AxiosResponse} from "axios";


export async function queryNotices(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/thsadmin/api/sys-notifications', { params: params });
}

export async function getNoticeDetails(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/thsadmin/api/sys-notifications/details', { params: params });
}

export async function setNoticeRead(data?: string) {
  return request.put<any, AxiosResponse<any[]>>(`/thsadmin/api/sys-notifications/read/${data}`);
}

export async function getUnreadCount() {
  return request.get<any, AxiosResponse<any>>('/thsadmin/api/sys-notifications/no-read-count');
}

export async function changeNoticeReadState(notices: any[]): Promise<any> {
  return request.post('/thsadmin/api/change-notices-read', notices);
}
